import { ResponsiveBar } from '@nivo/bar';
import { Currency } from '../../../types/common';
import { useChartLegendColor } from '../../../context/Theme';
import { Center } from '../types';

export const Bar = ({
  center,
  className,
  margin,
  barData,
  barColors,
  strategyValue,
  symbol,
  onClick = () => {},
  resetCenter,
  setCenter,
}: {
  center: Center;
  className: string;
  margin: number;
  barData;
  barColors?: string[];
  strategyValue: number;
  symbol: Currency['symbol'];
  onClick?(p?: any): any;
  resetCenter(): void;
  setCenter: React.Dispatch<React.SetStateAction<Center>>;
}) => {
  const chartTheme = useChartLegendColor();

  return (
    <div className={className}>
      <div
        className={`
            absolute
            top-0
            bottom-0
            left-0
            right-0
            oveflow-hidden
            bg-center
            z-20
        `}
      >
        <ResponsiveBar
          onMouseEnter={(p: any) => {
            setCenter({ id: p?.data?.id, value: p?.data?.year });
          }}
          onMouseLeave={() => {
            resetCenter();
          }}
          /* tooltip={() => <><div>ciao</div></>} */
          theme={chartTheme}
          data={barData}
          keys={['coupon', 'capital']}
          indexBy="year"
          margin={{ top: 40, right: 20, bottom: 40, left: 50 }}
          padding={0.8}
          valueScale={{ type: 'linear' }}
          indexScale={{ type: 'band', round: true }}
          colors={barColors}
          borderColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
          axisTop={null}
          axisRight={null}
          axisBottom={{
            tickSize: 5,
            tickPadding: 5,
            tickRotation: -45,
            //legend: 'categories',
            legendPosition: 'middle',
            legendOffset: 32,
          }}
          axisLeft={{
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            //legend: 'values',
            legendPosition: 'middle',
            legendOffset: -40,
          }}
          labelSkipWidth={12}
          labelSkipHeight={12}
          labelTextColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
          isInteractive={true}
          animate={false}
        />
      </div>
    </div>
  );
};
